export default __webpack_public_path__ + "static/media/Newsletter 027.fde704ba.png";